import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import enUS from '@assets/locales/en-US.json';

export const i18nLanguages = ['en-US'] as const;
export type i18nLanguage = (typeof i18nLanguages)[number];

export const LanguageMap: Record<string, i18nLanguage> = {
  enUS: 'en-US',
};

export const resources = {
  [LanguageMap.enUS]: { translation: enUS },
};

i18n.use(initReactI18next).init({
  interpolation: { escapeValue: false },
  keySeparator: '.',
  lng: LanguageMap.enUS,
  resources,
});

export default i18n;
